import React from 'react';
import './Auth.css';

interface KVKKModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const KVKKModal: React.FC<KVKKModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="kvkk-modal-backdrop" onClick={onClose}>
      <div className="kvkk-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="kvkk-header">
          <h3>KVKK ve Kişisel Verilerin Korunması Aydınlatma Metni</h3>
          <button className="kvkk-close-btn" onClick={onClose}>✕</button>
        </div>
        <div className="kvkk-body">
          <p>
            <strong>1. Veri Sorumlusu</strong><br />
            6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") uyarınca, Uzman Destek platformu olarak
            kişisel verilerinizin güvenliğine en üst düzeyde önem veriyoruz.
          </p>
          <p>
            <strong>2. İşlenen Kişisel Veriler ve İşleme Amaçları</strong><br />
            Platformumuza kaydınız esnasında paylaştığınız Ad, Soyad, E-posta adresi ve Telefon numarası;
            kullanıcı hesabınızın oluşturulması, e-posta doğrulaması yapılması, lisans süreçlerinin yönetilmesi
            ve sistem bildirimlerinin sağlanması amacıyla işlenmektedir.
          </p>
          <p>
            <strong>3. Veri Güvenliği ve Çift Taraflı Şifreleme</strong><br />
            Tüm kullanıcı verileri ve manuel işyeri kayıtları AES-256-GCM çift taraflı şifreleme ile veritabanında saklanmakta
            olup, üçüncü taraflarla kesinlikle paylaşılmamaktadır.
          </p>
          <p>
            <strong>4. Haklarınız</strong><br />
            KVKK’nın 11. maddesi uyarınca dilediğiniz zaman verilerinizin silinmesini, güncellenmesini veya işlenme durumunu
            talep edebilirsiniz.
          </p>
        </div>
        <div className="kvkk-footer">
          <button className="kvkk-ok-btn" onClick={onClose}>Anladım ve Kabul Ediyorum</button>
        </div>
      </div>
    </div>
  );
};

export default KVKKModal;
